import Vue from 'vue/dist/vue.js';
import { Loader } from '@googlemaps/js-api-loader';

Vue.config.productionTip = false;

const retailerMap = Vue.component('retailer-map',
    {
        delimiters: ['@{','}'],

        template: ` <div>
                        <div class="retailer-map retailer-map-component" :id="mapId()">
                        </div>
                    </div>`,

        props : [ 'retailer', 'height'],

        data: function()
        {
            return {
                map : null,
                mapOptions : null,
                google : null,
                center : null,
            }
        },

        created ()
        {
            setTimeout(this.initMap, 250);
        },

        updated ()
        {
            setTimeout(this.initMap, 250);
        },

        methods: {
            mapId()
            {
                return 'js_retailerMap-'+this.retailer.id;
            },

            initMap(id)
            {
                const loader = new Loader({
                    // apiKey: "", // TODO set api key
                    apiKey: "AIzaSyAv5wVkoYzK5x8jgvNq_VpIeYN1EUX1po0",
                    version: "weekly",
                    libraries: ["places", 'geometry']
                });

                loader.loadCallback(e => {
                  if (e) {

                  } else {
                    this.setupMapOptions();
                    const mapContainer = document.getElementById(this.mapId());
                    this.google = google;
                    this.map = new google.maps.Map(mapContainer, this.mapOptions);
                    this.placeItems();
                  }
                });
            },

            convertPositions()
            {
                const lng = parseFloat(this.retailer.position.lng);
                const lat = parseFloat(this.retailer.position.lat);
                return {lng: lng, lat: lat}
            },

            setupMapOptions()
            {
                const retailerPosition = this.convertPositions();

                this.center = retailerPosition;

                this.mapOptions = {
                    center: this.center,
                    zoom: 10
                };
            },

            placeItems(google)
            {
                new this.google.maps.Marker({
                    position: this.center,
                    map: this.map,
                });

            }
        },

});

export default retailerMap;